<template>
  <div class="text-right">
    {{ display }}
  </div>
</template>

<script>

import cellRendererMixin from '../../mixins/cellRenderer.mixin'

export default {
  mixins: [cellRendererMixin]
}
</script>
